import { ServerConnectionClosedMessage, StartSessionMessage } from "../../messages/session/SessionMessages";
import { ClientConnectionStatsMessage, ServerConnectionStatsMessage } from "flavr-common";
import { busService } from "../bus";
class NetworkStatsService {
    constructor() {
        this.connection = busService.connection("NetworkStatsService");
        this.serverConnectionLost = false;
        this.isDirty = false;
        this.handleClientConnectionStatsMessage = (msg) => {
            this.currentClientStats = msg.connectionStats;
            this.isDirty = true;
        };
        this.handleServerConnectionStatsMessage = (msg) => {
            this.serverConnectionLost = false;
            this.currentServerStats = msg.clients;
            this.isDirty = true;
        };
        this.handleStartSessionMessage = () => {
            this.serverConnectionLost = false;
        };
        this.handleServerConnectionClosedMessage = () => {
            this.serverConnectionLost = true;
        };
        this.connection.subscribeByType(ClientConnectionStatsMessage, this.handleClientConnectionStatsMessage);
        this.connection.subscribeByType(ServerConnectionStatsMessage, this.handleServerConnectionStatsMessage);
        this.connection.subscribeByType(StartSessionMessage, this.handleStartSessionMessage);
        this.connection.subscribeByType(ServerConnectionClosedMessage, this.handleServerConnectionClosedMessage);
    }
    process() {
        if (!this.isDirty)
            return false;
        if (!this.currentClientStats)
            return false;
        if (!this.currentServerStats)
            return false;
        // this.isDirty = false;
        return true;
    }
}
export const networkStatsService = new NetworkStatsService();
